import { components } from "react-select";
import { SIGNATURE_DOCUMENT_MAP } from "components/constant";

const CustomOption = (props) => {
  const { data, isSelected, isFocused } = props;

  const handleView = (e) => {
    e.stopPropagation();

    const url = SIGNATURE_DOCUMENT_MAP[data.value];
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <components.Option {...props}>
      <div className="certificate-option">
        <i
          className={`fa-solid fa-eye certificate-option-eye ${
            isSelected ? "selected" : ""
          }`}
          onClick={handleView}
        />

        <span>{data.label}</span>
      </div>
    </components.Option>
  );
};

export default CustomOption;
